<template>
  <div class="flex items-center justify-between mb-5 overflow-x-auto pb-1 w-full">
    <div class="flex h-8 shadow-lg w-fit rounded-full pr-3 pl-1 bg-g3" v-if="!$root.isPopup">
      <!-- <div class="w-8 mr-2 pl-2 flex items-center">
        <router-link
          :to="{ name: 'Home' }"
          title="Accueil"
          class="text-white hover:text-g0"
        >
          <svg
            class="w-[25px] fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 46.292"
          >
            <path
              d="M.69,32.09,7.9,30.452a16.757,16.757,0,0,1-.1-7.677L.589,21.137A23.812,23.812,0,0,0,.69,32.09Zm41.483-9.415a16.753,16.753,0,0,1-.1,7.877l7.215,1.638a23.809,23.809,0,0,0,.1-11.152Z"
              transform="translate(0 -3.468)"
            />
            <path
              d="M10.457,30.272l6.42-1.433a8.678,8.678,0,0,1-.1-3.993l-6.421-1.433a14.751,14.751,0,0,0,.1,6.859Zm24.757-5.526,6.42-1.433a14.748,14.748,0,0,1-.105,7.058l-6.421-1.433a8.675,8.675,0,0,0,.106-4.192Z"
              transform="translate(-1.006 -3.696)"
            />
            <path
              d="M4.129,11.672l6.326,3.588a16.5,16.5,0,0,1,2.611-3.03A17.559,17.559,0,0,1,16,10.066l-3.93-5.777A24.954,24.954,0,0,0,7.8,7.424,23.463,23.463,0,0,0,4.129,11.672ZM40.5,32.3a16.562,16.562,0,0,1-2.428,2.761A17.6,17.6,0,0,1,34.663,37.5l3.93,5.777a25,25,0,0,0,4.743-3.4,23.52,23.52,0,0,0,3.489-3.98Z"
              transform="translate(-0.415 -0.645)"
            />
            <path
              d="M12.626,17.024l5.645,2.863a8.217,8.217,0,0,1,1.445-1.513,9.414,9.414,0,0,1,1.462-.978L17.67,12.787a16.036,16.036,0,0,0-2.652,1.752A14.005,14.005,0,0,0,12.626,17.024ZM34.393,28.063l5.644,2.863a14.117,14.117,0,0,1-2.2,2.239,16.165,16.165,0,0,1-3.136,2L31.19,30.554a9.538,9.538,0,0,0,1.946-1.224A8.328,8.328,0,0,0,34.393,28.063Z"
              transform="translate(-1.27 -0.837)"
            />
            <path
              d="M12.138,43.216l3.93-5.776a17.585,17.585,0,0,1-3.318-2.384,16.572,16.572,0,0,1-2.37-2.679L4.053,35.964a23.54,23.54,0,0,0,3.432,3.9A25,25,0,0,0,12.138,43.216ZM34.731,10a17.568,17.568,0,0,1,3.023,2.217,16.484,16.484,0,0,1,2.666,3.113l6.326-3.588a23.441,23.441,0,0,0-3.727-4.331,24.962,24.962,0,0,0-4.358-3.186Z"
              transform="translate(-0.408 -0.638)"
            />
            <path
              d="M17.74,36.429l3.506-4.881A9.456,9.456,0,0,1,19.393,30.3a8.625,8.625,0,0,1-1.2-1.264L12.55,32.067A14.606,14.606,0,0,0,14.7,34.36,16.06,16.06,0,0,0,17.74,36.429ZM31.262,17.606l3.506-4.881a16.006,16.006,0,0,1,2.743,1.907,14.471,14.471,0,0,1,2.448,2.712l-5.645,3.033a8.491,8.491,0,0,0-1.5-1.683A9.406,9.406,0,0,0,31.262,17.606Z"
              transform="translate(-1.262 -1.493)"
            />
            <path
              d="M20.9.876l1.637,6.68a18.065,18.065,0,0,1,7.677-.093L31.853.782A25.67,25.67,0,0,0,20.9.876Zm9.415,38.407a18.058,18.058,0,0,1-7.877-.1L20.8,45.867a25.665,25.665,0,0,0,11.152.1Z"
              transform="translate(-1.376 -0.237)"
            />
            <path
              d="M23.176,10.641l1.433,5.676a9.785,9.785,0,0,1,3.993-.09l1.433-5.677a16.634,16.634,0,0,0-6.859.09ZM28.7,32.53l1.433,5.676a16.627,16.627,0,0,1-7.058-.093l1.433-5.677a9.779,9.779,0,0,0,4.192.094Z"
              transform="translate(-1.605 -1.243)"
            />
          </svg>
        </router-link>
      </div>
      <svg class="text-g0" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" aria-hidden="true" style="
          stroke: rgb(51 51 51 / var(--tw-text-opacity));
          stroke-width: 1.2px;
        ">
        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
      </svg> -->
      <div v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb" class="flex">
        <div class="h-8 w-max flex items-center px-2 font-semibold">
          <span v-if="typeof breadcrumb == 'object'">
            <router-link :to="breadcrumb.link" class="hover:text-g0">
              {{ $e(breadcrumb.name) }}
            </router-link>
          </span>
          <span v-else-if="breadcrumb != ''">{{ $e(breadcrumb) }}</span>
          <span v-else>{{ $e("Page") }} {{ index }}</span>
        </div>

        <svg v-if="breadcrumbs.length != index + 1" class="text-g0" viewBox="0 0 24 44" preserveAspectRatio="none"
          fill="currentColor" aria-hidden="true" style="
            stroke: rgb(51 51 51 / var(--tw-text-opacity));
            stroke-width: 1.2px;
          ">
          <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
        </svg>
      </div>
    </div>
    <div class="hidden lg:flex items-center w-full">
      <slot></slot>
    </div>
    <div class="flex items-center" v-if="showLog">
      <div class="bg-g2 flex items-center rounded-full group">
        <button @click="logout()" :title="$e('Se déconnecter')"
          class="w-0 group-hover:w-fit group-hover:py-1 group-hover:pl-3 group-hover:pr-2 transition-all ease-out hover:text-flyingeye-light duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="stroke w-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
          </svg>
        </button>
        <router-link :to="{ name: 'Home' }" :title="$e('Mon compte')"
          class="bg-g3 h-8 w-8 rounded-full p-1 hover:text-flyingeye-light">
          <svg class="stroke" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </router-link>
      </div>
    </div>
  </div>

  <div class="flex items-center lg:hidden w-full">
    <slot></slot>
  </div>
</template>
<script>


export default {
  name: "Back",
  props: {
    breadcrumbs: Array,
    showLog: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    logout() {
      $root.user.logout();
      window.location.reload();
    },
  },
};
</script>
